import { Component, OnInit } from '@angular/core';
import { E5coreUiDatagridBase } from './e5core-ui-datagrid-base';

@Component({
  selector: 'e5core-ui-datagrid-bootstrap',
  templateUrl: './e5core-ui-datagrid-bootstrap.component.html',
  styleUrls: ['./e5core-ui-datagrid-bootstrap.component.css']
})
export class E5coreUiDatagridBootstrapComponent extends E5coreUiDatagridBase implements OnInit {

  constructor() { 
    super() ;
  }

  ngOnInit() {
  }

}